import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Permissions from "../pages/Permissions";
import PropTypes from "prop-types";


const TenantListMenuItems = (props) => {
    const tenantMenuItems = props.tenantList?.map((tenantDict) =>
        <MenuItem key={tenantDict['tenantId']} value={tenantDict['tenantId']+'|'+tenantDict['tenantName']}>{tenantDict['tenantName']}</MenuItem>
    )
    return (
        <>
            <FormControl sx={{ m: 1, minWidth: 80 }}>
        <InputLabel id="demo-simple-select-autowidth-label">Tenant</InputLabel>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={props.tenant_select?props.tenant_select:''}
          onChange={props.handleChangeTenant}
          autoWidth
          label="Tenant"
          >
            {tenantMenuItems}
           </Select>
      </FormControl>
        </>
    )
}

TenantListMenuItems.propTypes = {
    tenantList: PropTypes.array,
    tenant_select: PropTypes.string,
    handleChangeTenant: PropTypes.func
}

export default TenantListMenuItems;